<template>
	<div class='page-start'>
		<mdb-row class='justify-content-center'>
			<mdb-col col='10'>
			<mdb-card>
				<h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">create new account</h3>
				<mdb-card-body>

				<!-- Submission Alerts -->
				<mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p10" @closeAlert="p10=false" dismiss>
					Success! User created! Go to View/Edit User Page? (Click "No" to start New User)
					<router-link :to="'/View-Edit-User-Page'"><mdbBtn class="QuadrusButton">Yes</mdbBtn></router-link>
					<mdbBtn color="danger" v-on:click="p10=false">No</mdbBtn>
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p11" @closeAlert="p11=false" dismiss>
					There was an error creating user! Please try again! Error Code P11
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p12" @closeAlert="p12=false" dismiss>
					{{submitErrorMsg}}
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p13" @closeAlert="p13=false" dismiss>
					There was an error fetching information from the database! Error Code P13
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p14" @closeAlert="p14=false" dismiss>
					There was an error fetching user data. Please try again! Error Code P14
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p15" @closeAlert="p15=false" dismiss>
					There was an error fetching user data. Please try again! Error Code P15
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p16" @closeAlert="p16=false" dismiss>
					There was an error fetching drect repot data. Please try again! Error Code P16
				</mdb-alert>
				<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p17" @closeAlert="p17=false" dismiss>
					There was an error fetching user access data. Please try again! Error Code P17
				</mdb-alert>
				
				<!-- /Submission Alerts -->

					<form @submit.prevent="checkForm" novalidate>
						<div class= 'grey-text text-left'>
							<mdb-container>
								<h3 class="h3-responsive">Account Information</h3>
								<mdb-input sm label='Username' id="usernameInput" v-model="validationValues.username" type='text' required 
									:customValidation="validation.username.validated"
									:isValid="validation.username.valid"
									@input="validate('username')"
									invalidFeedback="Username Invalid or Already in Use" validFeedback="Looks Good!" maxlength="50"/>
								<mdb-input sm label='E-mail' id="emailInput" v-model="validationValues.email" type='email' required 
									:customValidation="validation.email.validated"
									:isValid="validation.email.valid"
									@input="validate('email')"
									invalidFeedback="Email Invalid or Already in Use" validFeedback="Looks Good!" maxlength="100"/>
								<mdb-input sm label='Password' id="password" v-model="validationValues.password" type='password' required 
									:customValidation="validation.password.validated"
									:isValid="validation.password.valid"
									@input="validate('password')"
									invalidFeedback="Passwords must match and meet requirements" validFeedback="Looks Good!" maxlength="100"/>
								<a class='' style="color: #ff4444" v-if="!passwordLength"><mdb-icon icon="exclamation-circle" />At least 10 Characters Long Without spaces</a>
								<a class='' style="color: #00C851" v-if="passwordLength"><mdb-icon icon="check-circle" />At least 10 Characters Long Without Spaces</a>
								<br>
								<a class='' style="color: #ff4444" v-if="!passwordSpecial"><mdb-icon icon="exclamation-circle" />At least 1 Special Character, i.e. !, @, #, $, etc.</a>
								<a class='' style="color: #00C851" v-if="passwordSpecial"><mdb-icon icon="check-circle" />At least 1 Special Character, i.e. !, @, #, $, etc.</a>
								<br>
								<a class='' style="color: #ff4444" v-if="!passwordUpper"><mdb-icon icon="exclamation-circle" />At least 1 Uppercase Character</a>
								<a class='' style="color: #00C851" v-if="passwordUpper"><mdb-icon icon="check-circle" />At least 1 Uppercase Character</a>
								<br>
								<a class='' style="color: #ff4444" v-if="!passwordLower"><mdb-icon icon="exclamation-circle" />At least 1 Lowercase Character</a>
								<a class='' style="color: #00C851" v-if="passwordLower"><mdb-icon icon="check-circle" />At least 1 Lowercase Character</a>
								<br>
								<a class='' style="color: #ff4444" v-if="!passwordDigit"><mdb-icon icon="exclamation-circle" />At least 1 Numeric Character</a>
								<a class='' style="color: #00C851" v-if="passwordDigit"><mdb-icon icon="check-circle" />At least 1 Numeric Character</a>

								<mdb-input sm label='Verify Password' id="confirmPassword" v-model="validationValues.confirmPassword" type='password' required 
									:customValidation="validation.confirmPassword.validated"
									:isValid="validation.confirmPassword.valid"
									@input="validate('confirmPassword')"
									invalidFeedback="Passwords must match" validFeedback="Looks Good!" maxlength="100"/>
							</mdb-container>
							<br><hr><br>
							<mdb-container>
								<h3 class="h3-responsive">Personal Information</h3>
								<mdb-input sm label='First Name' id="fnameInput" v-model="validationValues.fname" group type='text' required 
									:customValidation="validation.fname.validated" 
									:isValid="validation.fname.valid"
									@input="validate('fname')"
									invalidFeedback="Required Field" validFeedback="Looks Good!" maxlength="100"/>
								<mdb-input sm label='Last Name' id="lnameInput" v-model="validationValues.lname" group type='text' required 
									:customValidation="validation.lname.validated" 
									:isValid="validation.lname.valid"
									@input="validate('lname')"
									invalidFeedback="Required Field" validFeedback="Looks Good!" maxlength="100"/>
								<mdb-date-picker-2 v-model="validationValues.dob" label= 'Date of Birth' id="dobInput" 
									ref="dobpicker" @change="validate('dob')" title= 'Select Date' disabledFuture
									@click="handleDobPickerClick"/>
								<div v-if="!validation['dob'].valid" class="invalid-feedback d-block">
									Invalid Date
								</div>

								<!--
								<mdb-input sm label='Personal E-mail' v-model="validationValues.personalEmail" group type='email' validFeedback="Optional"/>
								<mdb-input sm label='Personal Phone #' v-model="validationValues.personalPhone" group type='phone' validFeedback="Optional"/>
								<mdb-input sm label='Home Phone #' v-model="validationValues.homePhone" group type='phone' validFeedback="Optional"/>
								<br>
								<mdb-select v-model='countryOptions' @getValue='setCountry' label='Country' placeholder='Choose your Country' validFeedback="Optional"/>
								<mdb-input sm v-model="validationValues.street" label='Street' group type='text' validFeedback="Optional"/>
								<mdb-input sm v-model="validationValues.city" label='City' group type='text' validFeedback="Optional"/>
								<mdb-select v-model='stateOptions' @getValue='setState' label='State' placeholder='If in the US choose State' validFeedback="Optional"/>
								<mdb-input sm v-model="validationValues.zip" label='Zip Code' group type='number' validFeedback="Optional"/>
							-->
							</mdb-container>
							<br><hr><br>
							<mdb-container>
								<h3 class="h3-responsive">Professional Information</h3>
								
								<mdb-select label="Title" @getValue="setTitle" v-model="titleOptions"/>
								<div v-if="fieldsValidated && !validationValues.title" class="invalid-feedback d-block">
									Please select an option.
								</div>
								<div v-else-if="validationValues.title" class="valid-feedback d-block">
									Looks Good!
								</div>
								<mdb-select label="Department" @getValue="setDepartment" v-model="departmentOptions"/>
								<div v-if="fieldsValidated && !validationValues.department" class="invalid-feedback d-block">
									Please select an option.
								</div>
								<div v-else-if="validationValues.department" class="valid-feedback d-block">
									Looks Good!
								</div>
								<mdb-select label="Division" @getValue="setDivision" v-model="divisionOptions"/>
								<div v-if="fieldsValidated && !validationValues.division" class="invalid-feedback d-block">
									Please select an option.
								</div>
								<div v-else-if="validationValues.division" class="valid-feedback d-block">
									Looks Good!
								</div>
								
								<!--
								<mdb-input sm v-model="validationValues.title" label='Title' group type='text' validFeedback="Optional" maxlength="100"/>
								<mdb-input sm v-model="validationValues.division" label='Division' group type='text' validFeedback="Optional" maxlength="100"/>
								-->
								<mdb-select v-model="reportOptions" @getValue="setDirectReport" label="Direct Report"/>							
								<mdb-input sm label='Office Phone #' v-model="validationValues.workPhone" group type='tel'
									:customValidation="validation.workPhone.validated" 
									:isValid="validation.workPhone.valid"
									@input="validate('workPhone')"
									invalidFeedback="Not a valid phone number"/>
								<mdb-input sm label='Work Cell Phone #' v-model="validationValues.workCellPhone" group type='tel' 
									:customValidation="validation.workCellPhone.validated" 
									:isValid="validation.workCellPhone.valid"
									@input="validate('workCellPhone')"
									invalidFeedback="Not a valid phone number"/>

								<br>
								<div>
									<h3 class="h3-responsive">User Access</h3>
									<h5 class="h5-responsive"><u>NOTE:</u> Everyone has a default "Public" role that allows then to access basic functions. Only add below roles if more advanced functions are needed. </h5>

									<mdb-select multiple :options="accessLevels" :selected="accessLevels[2]" @getValue="setUserAccessLevel" label="User Access"/>
									<!--<mdb-input type="radio" id="access-1" name="UserAccessGroup" radioValue="CUS" v-model="validationValues.userAccess" label="CUS: Customer, Consultant" required/>
									<mdb-input type="radio" id="access-2" name="UserAccessGroup" radioValue="SRI" v-model="validationValues.userAccess" label="SRI:  Specialist, Associate, Assistant, Representative, Intern" required />
									<mdb-input type="radio" id="access-3" name="UserAccessGroup" radioValue="MGR" v-model="validationValues.userAccess" label="MGR: Manager, Supervisor" required />
									<mdb-input type="radio" id="access-4" name="UserAccessGroup" radioValue="DIR" v-model="validationValues.userAccess" label="DIR: Director" required />
									<mdb-input type="radio" id="access-5" name="UserAccessGroup" radioValue="ENG" v-model="validationValues.userAccess" label="ENG: Engineer, Developer (RE)" required />
									<mdb-input type="radio" id="access-6" name="UserAccessGroup" radioValue="QCM" v-model="validationValues.userAccess" label="QCM: Configuration Manager" required />
									<mdb-input type="radio" id="access-7" name="UserAccessGroup" radioValue="QPM" v-model="validationValues.userAccess" label="QPM: Project Manager" required />
									<mdb-input type="radio" id="access-8" name="UserAccessGroup" radioValue="QEM" v-model="validationValues.userAccess" label="QEM: Executive Management" required /> -->

								</div>


							</mdb-container>
							<br><hr><br>
							<!--
							<mdb-container>
								<h3 class="h3-responsive">Emergency Contact Information</h3>
								<br>
								<h5 class="h5-responsive">Contact One</h5>
								<mdb-input sm label='Emergency Contact Name' v-model="validationValues.emerNameOne" group type='text' validFeedback="Optional"/>
								<mdb-input sm label='Emergency Contact Number' v-model="validationValues.emerPhoneOne" group type='phone' validFeedback="Optional"/>
								<br>
								<h5 class="h5-responsive">Contact Two</h5>
								<mdb-input sm label='Emergency Contact Name' v-model="validationValues.emerNameTwo" group type='text' validFeedback="Optional"/>
								<mdb-input sm label='Emergency Contact Number' v-model="validationValues.emerPhoneTwo" group type='phone' validFeedback="Optional"/>
								<br>
								<h5 class="h5-responsive">Contact Three</h5>
								<mdb-input sm label='Emergency Contact Name' v-model="validationValues.emerNameThree" group type='text' validFeedback="Optional"/>
								<mdb-input sm label='Emergency Contact Number' v-model="validationValues.emerPhoneThree" group type='phone' validFeedback="Optional"/>
							</mdb-container>
							<br><hr><br>
							-->
							<mdb-container>
								<h3 class="h3-responsive">Other</h3>
								<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="wrongFile" @closeAlert="wrongFile=false" dismiss>
									Only image files are accepted.
								</mdb-alert>
								<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p18" @closeAlert="p18=false" dismiss>
									The chosen profile picture is too large, maximum file size is 1MB! Error Code P18
								</mdb-alert>
								<mdb-file-input @getValue="getProfilePic" sm btn-title='ADD PHOTO' btnColor='blue' :key="uploaderKey"/>
								<mdb-input sm label='Real Colors Result' v-model="validationValues.realColorResult" group type='text' maxlength="300"/>
							</mdb-container>
						</div>
						<br>
						<!--<mdb-btn block type="submit" class='pl-3 pr-3 QuadrusButton'>Submit New User</mdb-btn>-->
						<mdb-btn class="mt-4 QuadrusButton" type="submit" v-if="!submitProcessing">Submit New User</mdb-btn>
            <mdb-btn class="mt-4 QuadrusButton" v-if="submitProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Processing...
            </mdb-btn>
					</form>
				</mdb-card-body>
			</mdb-card>
			</mdb-col>
		</mdb-row>
	</div>
</template>

<script>
import { mdbInput, mdbBtn, mdbCard, mdbCardBody, mdbCol, mdbRow, mdbDatePicker2, mdbFileInput, mdbContainer, mdbSelect, mdbAlert, mdbIcon} from 'mdbvue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import defaultProfileImg from "@/assets/@profile-pics/profile2.jpg";
import * as sendEmail from '@/assets/js/email.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'CreateNewUser',
	components: {
		mdbInput,
		mdbBtn,
		mdbCard,
		mdbCardBody,
		mdbCol,
		mdbRow,
		mdbDatePicker2,
		mdbFileInput,
		mdbContainer,
		mdbSelect,
		mdbAlert,
		mdbIcon,
	},

	data() {
		return {
		
		p10: false,
		p11: false,
		p12: false,
		p13: false,
		p14: false,
		p15: false,
		p16: false,
		p17: false,
		p18: false,
		submitErrorMsg: "",
		wrongFile: false,
		uploaderKey: 0,

		titleOptions: [{text: "Accountant", value: "Accountant"},{text:"Associate", value: "Associate"}, {text: "CEO", value: "CEO"}, {text: "Chemist", value: "Chemist"},
			{text: "Controller", value: "Controller"}, {text: "Director", value: "Director"}, {text: "Engineer", value: "Engineer"}, 
			{text: "Executive Vice President", value: "Executive Vice President"}, {text: "FSO", value: "FSO"}, {text: "Intern", value: "Intern"}, 
			{text: "Manager", value: "Manager"}, {text: "Sr. Staff Engineer", value: "Sr. Staff Engineer"}, {text: "Sr. Technical Fellow", value: "Sr. Technical Fellow"},
			{text: "Staff Engineer", value: "Staff Engineer"}, {text: "Team Lead", value: "Team Lead"}, {text: "Technical Fellow", value: "Technical Fellow"},
			{text: "Technician", value: "Technician"}, {text: "Vice President Business Development", value: "Vice President Business Development"}
		],
		divisionOptions: [{text: "Corporate", value: "Corporate"}, {text: "QAM", value: "QAM"}, {text: "QES", value: "QES"}],
		departmentOptions: [{text: "Administration", value: "Administration"}, {text: "Corporate Development", value: "Corporate Development"}, 
			{text: "Executive", value: "Executive"}, {text: "Operations", value: "Operations"}
		],

		fieldsValidated: false,

		defaultPic: "",
		passwordLength: false,
		passwordSpecial: false,
		passwordUpper: false,
		passwordLower: false,
		passwordDigit: false,
		submitProcessing: false,

		validationValues: {
			username: "",
			password: "",
			confirmPassword: "",
			email: "",
			fname: "",
			lname: "",
			dob: "",
			workPhone: "",
			workCellPhone: "",
			/*
			personalEmail: "",
			personalPhone: "",
			homePhone: "",
			
			/*
			email: "",
			street: "",
			city: "",
			zip: "",
			*/
			title: "",
			division: "",
			department: "",
			reportsTo: "",
			userAccess: [],
			/*
			state: "",
			country: "",

			emerNameOne: "",
			emerNameTwo: "",
			emerNameThree: "",

			emerPhoneOne: "",
			emerPhoneTwo: "",
			emerPhoneThree: "",
			*/

			realColorResult: "",
		},

    validation: {
			username: {
				valid: false,
				validated: false
			},
			email: {
				valid: false,
				validated: false
			},
			password: {
				valid: false,
				validated: false
			},
			confirmPassword: {
				valid: false,
				validated: false
			},
			fname: {
				valid: false,
				validated: false
			},
			lname: {
				valid: false,
				validated: false
			},
			dob: {
				valid: false,
				validated: false
			},
			workPhone: {
				valid: false,
				validated: false
			},
			workCellPhone: {
				valid: false,
				validated: false
			},
			title: {
				valid: false,
				validated: false
			},
			division: {
				valid: false,
				validated: false
			},
			department: {
				valid: false,
				validated: false
			}
		},

		reportOptions: [],
		accessLevels: [],

		profilePic: { file: null },

		adminId: '',

		roleAdmin: '',
		}
  },

	methods: {
		initializeForm: async function() {
			await Object.keys(this.validationValues).forEach(async key => {
				if(!await this.validate(key)) {
					window.scroll({top: 0, behavior: 'smooth'});
					return;
				}
			})
		},
		handleDobPickerClick: function() {
			if (this.validation['dob'].validated && !this.validation['dob'].valid) {
				this.validationValues.dob = null;
				this.validation['dob'].valid = true;
				this.validation['dob'].validated = false;
			}
		},
		checkForm: async function() {
			window.scroll({top: 0, behavior: 'smooth'});

			let token = this.$store.getters.getToken;
			let isValid = true;
			this.submitProcessing = false;
			let holdEnteredPass = this.validationValues.password;

			await Object.keys(this.validationValues).forEach(async key => {
				if(!await this.validate(key)) {
					isValid = false;
					window.scroll({top: 0, behavior: 'smooth'});
					this.submitErrorMsg = "Missing required fields or invalid input.";
					this.p12 = true;
					return;
				}
			})

			if(!isValid) {
				return;
			}
			
			await Object.keys(this.validationValues).forEach(key => {
				this.validationValues[key] = sanitizeInput(this.validationValues[key], this.$sanitize);
			})
			// if newpass != sanitized password then not valid
			if (this.validationValues.password != holdEnteredPass){
				isValid = false;
				this.validationValues.password = "";
				this.validationValues.confirmPassword = "";	
				this.validation.password.valid = false;
				this.validation.confirmPassword.valid = false;
				this.passwordLength = false;
				this.passwordSpecial = false;
				this.passwordUpper = false;
				this.passwordLower = false;
				this.passwordDigit = false;
				window.scroll({top: 0, behavior: 'smooth'});
				this.submitErrorMsg = "Please try another password.";
				this.p12 = true;
				return;
			}

			if(!isValid) {
				return;
			}

			let query = "filters[username][$eq][0]="+this.validationValues['username'];
			let response =  '';

			try {
				response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
			} catch (error) {
				window.scroll({top: 0, behavior: 'smooth'});
				this.p14 = true;
				return;
			}

			if (response.data.length != 0 || !this.validationValues['username']) {
				this.validation['username'].valid = false;
				isValid = false;
			} else if(response.data.length == 0 && this.validationValues['username']) {
				this.validation['username'].valid = true;
			}
			this.validation['username'].validated = true;

			query = "filters[email][$eq][0]="+this.validationValues['email'];
			response =  '';
			try {
				response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
			} catch (error) {
				window.scroll({top: 0, behavior: 'smooth'});
				this.p15 = true;
				return;
			}

			if (response.data.length != 0 || !this.validationValues['email']) {
				this.validation['email'].valid = false;
				isValid = false;
			} else if(response.data.length == 0 && this.validationValues['email']) {
				this.validation['email'].valid = true;
			}
			this.validation['email'].validated = true;

			if(isValid) {
				this.submitProcessing = true;
				this.submittedAddUser();
			} else {
				window.scroll({top: 0, behavior: 'smooth'});
				this.submitErrorMsg = "Missing required fields or invalid input.";
				this.p12 = true;
			}
		},

		//===========================================================================================
		//	Method Name	:	resetForm
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Refreshes page to reset fields and CSS.
		//===========================================================================================
		resetForm: function() 
		{
			//this.$router.go(0);
			//reset data
			this.validationValues.username = '';
			this.validationValues.email = '';
			this.validationValues.fname = '';
			this.validationValues.lname = '';
			this.validationValues.password = '';
			this.validationValues.dob = '';
			this.validationValues.confirmPassword = '';
			this.validationValues.title = '';
			this.validationValues.division = '';
			this.validationValues.department = '';
			this.validationValues.userAccess = [];
			this.validationValues.workPhone = '';
			this.validationValues.workCellPhone = '';
			this.validationValues.realColorResult = '';
			this.validationValues.reportsTo = '';
			this.profilePic = { file: null };

			//reset validation
			Object.keys(this.validation).forEach(key => {
				this.validation[key].validated = false;
				this.validation[key].valid = false;
			})

			//reset errors
			this.submitErrorMsg = '';
			this.p12 = false;
			this.p13 = false;
			this.p14 = false;
			this.p15 = false;
			this.p16 = false;
			this.p17 = false;
			this.p18 = false;

			this.submitProcessing = false;

			this.titleOptions = [{text: "Accountant", value: "Accountant"},{text:"Associate", value: "Associate"}, {text: "CEO", value: "CEO"}, {text: "Chemist", value: "Chemist"},
				{text: "Controller", value: "Controller"}, {text: "Director", value: "Director"}, {text: "Engineer", value: "Engineer"}, 
				{text: "Executive Vice President", value: "Executive Vice President"}, {text: "FSO", value: "FSO"}, {text: "Intern", value: "Intern"}, 
				{text: "Manager", value: "Manager"}, {text: "Sr. Staff Engineer", value: "Sr. Staff Engineer"}, {text: "Sr. Technical Fellow", value: "Sr. Technical Fellow"},
				{text: "Staff Engineer", value: "Staff Engineer"}, {text: "Team Lead", value: "Team Lead"}, {text: "Technical Fellow", value: "Technical Fellow"},
				{text: "Technician", value: "Technician"}, {text: "Vice President Business Development", value: "Vice President Business Development"}
			];
			this.divisionOptions = [{text: "Corporate", value: "Corporate"}, {text: "QAM", value: "QAM"}, {text: "QES", value: "QES"}];
			this.departmentOptions = [{text: "Administration", value: "Administration"}, {text: "Corporate Development", value: "Corporate Development"}, 
				{text: "Executive", value: "Executive"}, {text: "Operations", value: "Operations"}
			];

			this.populateUserAccess();
			this.populateDirectReports();
			this.initializeForm();
		},

		
		validate: async function(key) {
			this.fieldsValidated = true;
			
			if(key == 'title' || key == 'division' || key == 'department') {
				if(!this.validationValues[key]) {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else {
					this.validation[key].valid = true;
				}
				this.validation[key].validated = true;
			}

			if(key === 'email'){
				let regex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
				if(!this.validationValues[key]) {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else if(regex.test(this.validationValues[key])) {
					this.validation[key].valid = true;
				} else {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				}
				this.validation[key].validated = true;
			}

			if(key === 'username'){
				let regex = new RegExp(/^[A-Za-z0-9]+$/);
				if(!this.validationValues[key]) {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else if(regex.test(this.validationValues[key])) {
					this.validation[key].valid = true;
				} else {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				}
				this.validation[key].validated = true;
			}


			if(key === 'password' || key === 'confirmPassword') {
				this.checkPassword(this.validationValues['password']);
				if(this.validationValues['password'] == this.validationValues['confirmPassword'] 
				&& this.validationValues['confirmPassword'] != ''){
					this.validation['confirmPassword'].valid = true;
					this.validation['confirmPassword'].validated = true
				} else {
					this.validation['confirmPassword'].valid = false;
					this.validation['confirmPassword'].validated = true
				}

				if (this.validationValues['password'] != this.validationValues['confirmPassword'] 
				|| (this.validationValues['password'] == '' && this.validationValues['confirmPassword'] == '') 
				|| !this.passwordLength || !this.passwordSpecial || !this.passwordUpper || !this.passwordLower 
				|| !this.passwordDigit) {
					this.validation['password'].valid = false;
					//this.validation['confirmPassword'].valid = false;

					this.validation['password'].validated = true;
					//this.validation['confirmPassword'].validated = true

					return false;

				} else if(this.validationValues['password'] == this.validationValues['confirmPassword'] 
				&& this.validationValues['password'] != '' &&  this.validationValues['confirmPassword'] != '' 
				&& this.passwordLength && this.passwordSpecial && this.passwordUpper && this.passwordLower 
				&& this.passwordDigit) {
					this.validation['password'].valid = true;
					//this.validation['confirmPassword'].valid = true;
					this.valid = true;
				} 

				this.validation['password'].validated = true;
				this.validation['confirmPassword'].validated = true
			}

			if(key === 'fname' || key === 'lname') {
				// Place the hyphen at the very end so JavaScript treats it as a literal hyphen
				let regex = new RegExp(/^[\p{L}]+(?:[ '’.-][\p{L}]+)*$/u);

				if(this.validationValues[key] == '') {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else if(this.validationValues[key] != '' && regex.test(this.validationValues[key])) {
					this.validation[key].valid = true;
				} else {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				}
				this.validation[key].validated = true;
			}

			if(key === 'workPhone' || key === 'workCellPhone') {
				let regex = new RegExp('^\\+?(\\d{1,3})?[\\s.-]?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$');
				if(this.validationValues[key] != '') {
					if(regex.test(this.validationValues[key])) {
						this.validation[key].valid = true;
						this.validation[key].validated = true;
					} else {
						this.validation[key].valid = false;
						this.validation[key].validated = true;
						return false;
					}
				} else {
					this.validation[key].validated = true;
					this.validation[key].valid = true;
				}
			}

			if(key === 'dob') {
				if (this.validationValues['dob']) {
					const dob = this.validationValues['dob'];
					// Accept YYYY/MM/DD, YYYY-MM-DD, MM/DD/YYYY, and MM-DD-YYYY
					const match = /^(\d{2,4})[/-](\d{2})[/-](\d{2,4})$/.exec(dob);
					if (!match) {
						this.validation['dob'].valid = false;
						this.validation['dob'].validated = true;
						return false;
					} else {
						let year;
						let month;
						let day;
						// Determine whether the format is YYYY/MM/DD or MM/DD/YYYY
						if (match[1].length === 4) {
							year = Number(match[1]);
							month = Number(match[2]);
							day = Number(match[3]);
						} else if (match[3].length === 4) {
							month = Number(match[1]);
							day = Number(match[2]);
							year = Number(match[3]);
						} else {
							// Neither the first nor last part is a 4-digit year
							this.validation['dob'].valid = false;
							this.validation['dob'].validated = true;
							return false;
						}
						// Create the date
						const date = new Date(year, month - 1, day);
						// Make sure JavaScript didn't roll the date over
						const isValidDate =
							date.getFullYear() === year &&
							date.getMonth() === month - 1 &&
							date.getDate() === day;

						// Today's date without time
						const today = new Date();
						today.setHours(0, 0, 0, 0);
						if (!isValidDate || date > today) {
							this.validation['dob'].valid = false;
							this.validation['dob'].validated = true;
							return false;
						} else {
							this.validation['dob'].valid = true;
						}
					}
				} else {
					this.validation['dob'].valid = true;
				}
				this.validation['dob'].validated = true;
			}
			
			return true;

		},

		checkPassword: function(value) {
			let regex = '';
			regex = new RegExp('^\\S{10,30}$');

			if(regex.test(value)) {
				this.passwordLength = true;
			} else {
				this.passwordLength = false;
			}

			regex = new RegExp('[\\!@#\\$%\\^\\&\\*\\(\\)\\-\\_\\=\\+\\|;:\'",.\\/\\?`~]+');

			if(regex.test(value)) {
				this.passwordSpecial = true;
			} else {
				this.passwordSpecial = false;
			}

			regex = new RegExp('[A-Z]+');

			if(regex.test(value)) {
				this.passwordUpper = true;
			} else {
				this.passwordUpper = false;
			}

			regex = new RegExp('[a-z]+');

			if(regex.test(value)) {
				this.passwordLower = true;
			} else {
				this.passwordLower = false;
			}

			regex = new RegExp('[0-9]+');
			if(regex.test(value)) {
				this.passwordDigit = true;
			} else {
				this.passwordDigit = false;
			}
			let pass = document.getElementById('password');
			let confpass = document.getElementById('confirmPassword');
			if(pass == confpass){
				this.validation.password.valid = true;
			}
		},

		submittedAddUser: async function() {
			let token = this.$store.getters.getToken;
			try {
				let data = {
					blocked: false,
					confirmed: true,
					username: this.validationValues.username,
					email: this.validationValues.email,
					password: this.validationValues.password,
					provider: 'local',
					firstName: this.validationValues.fname,
					lastName: this.validationValues.lname,
					dob: new Date(this.validationValues.dob) || null,
					/*
					personalEmail: this.validationValues.personalEmail,
					personalPhone: this.validationValues.personalPhone,
					homePhone: this.validationValues.homePhone,
					*/
					workPhone: this.validationValues.workPhone,
					workCellPhone: this.validationValues.workCellPhone,
					/*
					country: this.validationValues.country,
					street: this.validationValues.street,
					city:  this.validationValues.city,
					state: this.validationValues.state,
					zip: this.validationValues.zip,
					*/
					title: this.validationValues.title,
					division: this.validationValues.division,
					department: this.validationValues.department,
					reportsTo: this.validationValues.reportsTo,
					/*
					emerNameOne: this.validationValues.emerNameOne,
					emerNameTwo: this.validationValues.emerNameTwo,
					emerNameThree: this.validationValues.emerNameThree,
					emerPhoneOne: this.validationValues.emerPhoneOne,
					emerPhoneTwo: this.validationValues.emerPhoneTwo,
					emerPhoneThree: this.validationValues.emerPhoneThree,
					*/
					groups: this.validationValues.userAccess.map(Number),
					realColor: this.validationValues.realColorResult
				};

				await DatabaseLib.postRequest('strapiDatabase','auth/local/register',token,data);

				// Sets User Profile Pic
				if (this.profilePic.file !== null)
				{
					let query = "filters[username][$eq][0]=" + this.validationValues.username + "&populate[1]=profilePic";
				
					// Gets New User's ID
					let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
					let userId = response.data[0].id;
					
					let imageUpload = new FormData();
					imageUpload.append('files', this.profilePic.file, this.validationValues.username + '.jpg');
					imageUpload.append('ref', 'user');
					imageUpload.append('refId', userId);
					imageUpload.append('field', 'profilePic');
					imageUpload.append('source', 'users-permissions');
					
					response = await DatabaseLib.postRequest('strapiDatabase','upload',token,imageUpload);
					data = {
						profilePic: response.data
					}
					response = await DatabaseLib.putRequest('strapiDatabase','users',token,userId,data);
				}
				else
				{
					let query = "filters[username][$eq][0]=" + this.validationValues.username;

					// Gets New User's ID
					let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
					let userId = response.data[0].id;
					await DatabaseLib.putRequest('strapiDatabase','users',token,userId,this.defaultPic);
				}

				// Sets Role to Administrator if in Administration Group, else sets role to Authenticated
				if (this.adminId != "" && this.validationValues.userAccess.includes(this.adminId))
				{
					let roleData = 
					{
						role: this.roleAdmin
					};

					let query = "filters[username][$eq][0]=" + this.validationValues.username;

					// Gets New User's ID
					let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);

					let userId = response.data[0].id;
					
					// Updates Role to Administrator
					await DatabaseLib.putRequest('strapiDatabase','users',token,userId,roleData);
				}
				

				window.scroll({top: 0, behavior: 'smooth'});
				this.p10 = true;
				this.submitProcessing = false;
			
			} catch (error) {
				console.error("submittedAddUser ERROR:", error);
				console.error("Response:", error.response);
				console.error("Message:", error.message);

				window.scroll({top: 0, behavior: 'smooth'});
				this.p11 = true;
				this.submitProcessing = false;
				return;
			}

			//send email
			try{
				await sendEmail(this.validationValues.email, "QCDB Account Created", "Your account on QCDB has been created.<br>Email: " + this.validationValues.email + "<br>Password: " + this.validationValues.password, token, "", []);
			} catch (error) {
				console.error('Failed to send email', error);
			}

			this.resetForm();
		},

		// value[0].size = image size in bytes (5244276 = 5MB)
		// max size is 1MB (1,048,855)

		getProfilePic: function(value) {
			if(!value[0].type || !value[0].type.startsWith('image/')){
				// Reject the file
				this.wrongFile = true;
				this.uploaderKey++;
				return;
			}
			if (value[0].size >= 1048855) {
				this.uploaderKey++;
				this.p18 = true;
				return;
			}
			this.wrongFile = false;
			this.p18 = false;
			this.profilePic.file = value[0];
		},


		setUserAccessLevel: async function(value) {
			this.validationValues.userAccess = value;
		},

		setRoles: async function()
		{
			try 
			{
				let token = this.$store.getters.getToken;
				let response = await DatabaseLib.getRequest('strapiDatabase','users-permissions/roles',token, '', false);
				response.data.roles.forEach(role => {
					if (role.name === 'Admin')
					{
						this.roleAdmin = role.id;
					}
				});
			}
			catch (error) {
				window.scroll({top: 0, behavior: 'smooth'});
				this.p13 = true;
				this.submitProcessing = false;
				return;		
			}
		},

		populateUserAccess: async function() {
			let token = this.$store.getters.getToken;
			this.accessLevels = [];

			let groups = '';
			
			try {
				groups = await DatabaseLib.getRequest('strapiDatabase','groups',token);
			} catch (error) {
				window.scroll({top: 0, behavior: 'smooth'});
				this.p16 = true;
				this.submitProcessing = false;
				return;
			}
			
			for(let i = 0; i < groups.data.data.length; i = i + 1) {
				//Gets Group ID in case role needs to be changed to Administrator
				if (groups.data.data[i].attributes.name === 'Admin')
				{
					this.adminId = groups.data.data[i].id;
				}

				let obj = {};
				obj["text"] = groups.data.data[i].attributes.name;
				obj["value"] = groups.data.data[i].id;
				if(obj["text"] == "Employee"){
					obj["selected"] = true;
					//obj["disabled"] = true;
				}
				this.accessLevels.push(obj);
			}
		},
		
		populateDirectReports: async function() {
			let token = this.$store.getters.getToken;
			let query = "filters[blocked][$eq][0]="+false+"&populate[1]=groups&populate[2]=role";
			this.reportOptions = [];
			
				//Default Option
			let none = {};
			none["text"] = "None";
			none["value"] = "None";
			none["selected"] = true;
			this.reportOptions.push(none);

			let response = '';
			try {
				response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
			} catch (error) {
				window.scroll({top: 0, behavior: 'smooth'});
				this.p17 = true;
				this.submitProcessing = false;
				return;
			}
			let sup = [];
			for(let c = 0; c < response.data.length; c = c + 1){
				if(response.data[c].role.name != "Administrator"){
					for(let i = 0; i < response.data[c].groups.length; i = i + 1) {
						if(response.data[c].groups[i].name == "Supervisor"){
							sup.push(response.data[c]);
						}
					}
				}
			}


			sup.forEach(supervisor => {
				let obj = {};
				obj["text"] = supervisor.firstName + ' ' + supervisor.lastName;
				obj["value"] = supervisor.username;
				this.reportOptions.push(obj);
			});
			this.submitProcessing = false;
		},

		setDirectReport: function(value) 
		{
			this.validationValues.reportsTo = value;
		},
		setTitle: function(value) 
		{
			this.validationValues.title = value;
		},
		setDivision: function(value) 
		{
			this.validationValues.division = value;
		},
		setDepartment: function(value) 
		{
			this.validationValues.department = value;
		},

		setCountry: function(value) {
			this.validationValues.country = value;
		},

		setState: function(value) {
			this.validationValues.state = value;
		},
		
		loadImage: async function(src) {
			var img = new Image();
			img.src = src;
			img.crossOrigin="anonymous";
			await img.decode();
			return img;
		},

		getImages: async function(){
			var imgSource = "";
			let imgMatch = "";
			this.defaultPic = {
				profilePic: "1"
			};

			// get base64 value of default image
			this.loadImage(defaultProfileImg)
			.then(defaultImg => {
				var can = document.createElement("canvas");
				can.width = defaultImg.width;
				can.height = defaultImg.height;
				var ctx = can.getContext("2d");
				ctx.drawImage(defaultImg, 0, 0);
				imgSource = can.toDataURL();
			})
			.catch(err => console.error(err));
		
			//compare default image base64 value with images in the database to set the profile picture as default
			let token = this.$store.getters.getToken;
			let response2 = await DatabaseLib.getRequest('strapiDatabase','upload/files',token,"");

			for(var i = 0; i < response2.data.length; i++){
				var imageUrl = DatabaseLib.getEndpoint('strapiDatabase') + response2.data[i].url.substring(1);
				let holdId = response2.data[i].id;

				this.loadImage(imageUrl)
				.then(img => {

					var canvas = document.createElement("canvas");
					canvas.width = img.width;
					canvas.height = img.height;
					var ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0);
					imgMatch = canvas.toDataURL();
					
					if(imgMatch != "" && imgSource != ""){
						if(imgMatch === imgSource){
							this.defaultPic = {
								profilePic: holdId
							};
						}
					}
				})
				.catch(err => console.error(err + " -- " + imageUrl));
			}
			
		}
	},
	beforeDestroy() {
		const picker = this.$refs.dobpicker;
		if (picker && picker.$el) {
			const button = picker.$el.querySelector('i');
			if (button) {
				button.removeEventListener('click', this.handleDobPickerClick, true);
			}
		}
	},
	mounted() {
		this.populateUserAccess();
		this.setRoles();
		this.populateDirectReports();
		this.getImages();
		this.initializeForm();
		this.$nextTick(() => {
			const picker = this.$refs.dobpicker;
			if (picker && picker.$el) {
				const button = picker.$el.querySelector('i');

				if (button) {
					button.addEventListener('click', this.handleDobPickerClick, true);
				}
			}
		});
	},

}

</script>